import {createAction, props} from "@ngrx/store";
import {CreateRelatedCasesCommand, RelatedCasesDto} from "@esa/api";

export const getRelatedCasesById = createAction(
  '[Related Cases] Get Related Cases By ID',
  props<{ parentCaseId: string }>()
)
export const getRelatedCasesByIdSuccess = createAction(
  '[Related Cases] Get Related Cases By ID Success',
  props<{ relatedCases: RelatedCasesDto[] }>()
)
export const getRelatedCasesByIdError = createAction(
  '[Related Cases] Get Related Cases By ID Error',
)

export const createRelatedCase = createAction(
  '[Related Cases] Create Related Case',
  props<{ relatedCase: CreateRelatedCasesCommand }>()
)
export const createRelatedCaseSuccess = createAction(
  '[Related Cases] Create Related Case Success',
)
export const createRelatedCaseError = createAction(
  '[Related Cases] Create Related Case Error',
)
